import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import IntroScreen from "./components/IntroScreen";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import VIBEFramework from "./components/VIBEFramework";
import ProblemSolution from "./components/ProblemSolution";
import About from "./components/About";
import Services from "./components/Services";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StudioBuilderPage from "./components/StudioBuilderPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [showIntro, setShowIntro] = useState(true);
  const [introCompleted, setIntroCompleted] = useState(false);
  const [introPhase, setIntroPhase] = useState(1);

  const handleIntroComplete = () => {
    setShowIntro(false);
    // Remove all inline styles after the CSS transition finishes
    // This prevents filter: blur(0px) from creating a containing block
    // that interferes with IntersectionObserver in child components
    setTimeout(() => setIntroCompleted(true), 900);
  };

  // Calculate blur based on intro phase
  const getBlurAmount = () => {
    if (introPhase < 3) return 'blur(20px)';
    if (introPhase === 3) return 'blur(8px)';
    return 'blur(0px)';
  };

  const getOpacity = () => {
    if (introPhase < 3) return 0.3;
    if (introPhase === 3) return 0.7;
    return 1;
  };

  // Once intro is fully complete, remove ALL inline styles to avoid
  // creating a CSS containing block that breaks IntersectionObserver
  const wrapperStyle = introCompleted ? undefined : {
    filter: showIntro ? getBlurAmount() : 'blur(0px)',
    opacity: showIntro ? getOpacity() : 1,
    transition: 'filter 0.8s ease-out, opacity 0.8s ease-out',
  };

  return (
    <div className="min-h-screen bg-obsidian">
      {showIntro && (
        <IntroScreen 
          onComplete={handleIntroComplete} 
          onPhaseChange={setIntroPhase}
        />
      )}
      
      {/* Navbar outside the blur wrapper so it's always visible */}
      <Navbar />
      
      <div style={wrapperStyle}>
        <Hero />
        <ProblemSolution />
        <VIBEFramework />
        <About />
        <Services />
        <Pricing />
        <Testimonials />
        <FAQ />
        <Contact />
        <Footer />
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/studio-builder" element={<StudioBuilderPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
